import {
  BalanceAIIcon,
  BarcodeIcon,
  CalendarIcon,
  CropIcon,
  ItemsIcon,
  MoneyIcon,
} from 'common/icons';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'src/auth';
import { DrawerId, useDrawer } from 'src/common/components/drawer-manager';
import {
  BlueColors,
  GreenColors,
  PurpleColors,
  RedColors,
  YellowColors,
} from 'theme';

import * as Styled from './conversation-empty.style';

interface ConversationEmptyProps {
  onPromptSelect: (prompt: string) => void;
}

const ConversationEmpty = ({ onPromptSelect }: ConversationEmptyProps) => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const { open: openDrawer } = useDrawer();
  const items = [
    {
      key: '1',
      icon: <BalanceAIIcon style={{ fill: PurpleColors[60] }} />,
      description: t('cropwise_ai.what_can_i_do'),
    },
    {
      key: '2',
      icon: <CropIcon style={{ fill: YellowColors[40] }} />,
      description: t('cropwise_ai.season_costs'),
    },
    {
      key: '3',
      icon: <MoneyIcon style={{ fill: BlueColors[50] }} />,
      description: t('cropwise_ai.dollar_order'),
    },
    {
      key: '4',
      icon: <ItemsIcon style={{ fill: RedColors[50] }} />,
      description: t('cropwise_ai.negative_stock'),
    },
    {
      key: '5',
      icon: <CalendarIcon style={{ fill: PurpleColors[60] }} />,
      description: t('cropwise_ai.expensive_season'),
    },
    {
      key: '6',
      icon: <BarcodeIcon style={{ fill: GreenColors[40] }} />,
      description: t('cropwise_ai.overdue_invoice'),
    },
  ];

  const handleTagClick = (description: string) => {
    onPromptSelect(description);
  };

  return (
    <Styled.Container>
      <Styled.ConversationContainer>
        <Styled.Title>
          {t('cropwise_ai.greeting', { name: user?.name })}
        </Styled.Title>
        <Styled.ContainerTags>
          {items.map((item) => (
            <Styled.Tag
              key={item.key}
              onClick={() => handleTagClick(item.description)}
            >
              {item.icon}
              {item.description}
            </Styled.Tag>
          ))}
        </Styled.ContainerTags>
      </Styled.ConversationContainer>
      <Styled.VoiceContainer onClick={() => openDrawer(DrawerId.BalanceAi)}>
        <img src="/assets/voice-management.png" alt="Voice Management" />
        <Styled.VoiceDescription>
          <Styled.VoiceTitle>
            {t('cropwise_ai.voice_management')}
          </Styled.VoiceTitle>
          {t('cropwise_ai.voice_management_description')}
        </Styled.VoiceDescription>
      </Styled.VoiceContainer>
    </Styled.Container>
  );
};

export { ConversationEmpty };
